import getLoyaltyDefaultTier from 'loyalty/selectors/getLoyaltyDefaultTier'

function getLoyaltyEligibleTier(state: App.State): App.LoyaltyTier {
  const eligibilityTier = state.loyalty.eligibilityTier.data

  return eligibilityTier ?? getLoyaltyDefaultTier()
}

export default getLoyaltyEligibleTier
